var ChangedSportsModifier = /** @class */ (function () {
    function ChangedSportsModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    ChangedSportsModifier.prototype.modify = function (content) {
        if (content.sports === undefined || content.sports.change === undefined) {
            return;
        }
        var sports = content.sports.change;
        for (var i = 0; i < sports.length; i++) {
            var sport = sports[i];
            var key = this._modelKeyRepository.getSportKey(sport.id);
            sports[i] = Object.assign({
                name: sport.n,
                priority: sport.p
            }, key);
        }
    };
    return ChangedSportsModifier;
}());
export default ChangedSportsModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/ChangedSportsModifier.js